(function ($) {
  DJ.addBehavior('inputLabels', '.contact-form .form-item, .js-form-labels .form-item', {
    attach: function () {
      const formItem = this;
      const formInput = formItem.querySelector('[type=\'text\'], [type=\'password\'], [type=\'tel\'], [type=\'email\'], textarea');
      const formItemFocusClass = 'form-item--in-focus';

      if (!formInput) {
        return;
      }

      if (formInput.value.length !== 0) {
        formItem.classList.add(formItemFocusClass);
      }

      formInput.addEventListener('focus', () => {
        formItem.classList.add(formItemFocusClass);
      });

      formInput.addEventListener('blur', () => {
        if (formInput.value.length === 0) {
          formItem.classList.remove(formItemFocusClass);
        }
      });
    }
  });

  DJ.addBehavior('contactDataLayerWebformEvents', '.contact-form .webform-submission-form', {
    attach: function (context, settings) {
      const $form = $(this);
      const event = {};

      window.dataLayer = window.dataLayer || [];

      $form.on('submit', function (e) {
        event.event = 'generate_lead';

        if ($('.map-contact', context).length) { // /contact-us?product=ID.
          const data = $('.map-contact', context).first().data();
          event.companyName = (data.name) ? data.name : '';
          event.contactType = (data.type) ? data.type : '';
        } else if ($('.network__inner', context).length) { // /contact-us?company=ID.
          const data = $('.network__inner', context).first().parent('.network').data();
          event.productName = (data.name) ? data.name : '';
        }

        dataLayer.push(event);
      });
    }
  });
})(jQuery);
